import { ConfigService } from '@app-core/services';
import { ProductFilter } from '@app-model/filters/product-filter';
import { ProductItem } from '@app-model/response';

const metals = {
  BRNZ: 'BRONZE',
  SILV: 'SILVER',
  GOLD: 'GOLD',
  PLAT: 'PLATINUM',
};

export const planCodeMetal = (planCode: string): string | undefined => {
  const match = Object.keys(metals).find((metal) => planCode.includes(metal));

  return match ? metals[match] : undefined;
};

export const planMatch = (plan: ProductFilter, product: ProductItem): boolean => {
  if (product.productCategory === 'MULTICOVERAGE') {
    if (product.isBundled) {
      if (product.isDiscounted) {
        if (
          ConfigService.getEnvironment().features.bundleMultiCoveragePlansByMetal &&
          planCodeMetal(product.planCode)
        ) {
          return plan.name === planCodeMetal(product.planCode);
        } else {
          return plan.name === 'BUNDLES' && plan.productCode === product.productCode;
        }
      } else {
        return plan.name === 'PRODUCT COMBINATIONS';
      }
    }
  }

  return plan.planCode === product.planCode && plan.productCode === product.productCode;
};
